'use client'

import { STATUS_LABEL } from '@/data/platform'
import type { Status } from '@/data/platform'
import { cn } from '@/lib/utils'

const CLASS: Record<Status, string> = {
    live: 'pill-live',
    dev: 'pill-soon',
    soon: 'pill-soon',
    idea: 'pill-neutral',
}

const StatusPill = ({ status, className }: { status: Status; className?: string }) => (
    <span className={cn('pill', CLASS[status], className)}>{STATUS_LABEL[status]}</span>
)

export default StatusPill
